const phoneNumbers = Array.from(document.getElementsByClassName('00N0900000ILbRl'));
const postalCodes = Array.from(document.getElementsByClassName('00N0900000ILbRn'));

const mobilePhoneField = document.getElementById('mobile');
if (mobilePhoneField)
    phoneNumbers.push(mobilePhoneField);

if (phoneNumbers) {
    phoneNumbers.forEach((phoneNumber) => {
        phoneNumber.addEventListener("keydown", (e) => {
            const oldValue = phoneNumber.value;

            setTimeout(() => {
                let needCheck = true;
                if (phoneNumber.value.indexOf('0032') === 0) {
                    needCheck = false;
                }
                if (needCheck && phoneNumber.value.indexOf('0031') !== 0 || !(/^[0-9+-]+$/.test(phoneNumber.value))) {
                    phoneNumber.value = oldValue;
                }
            });
        });

        phoneNumber.addEventListener("paste", () => {
            const oldValue = phoneNumber.value;

            setTimeout(() => {
                if (!(/^[0-9+-]+$/.test(phoneNumber.value))) {
                    phoneNumber.value = oldValue;
                }
                let needCheck = true;
                if (phoneNumber.value.indexOf('0032') === 0) {
                    needCheck = false;
                }
                if (needCheck && !phoneNumber.value.startsWith("0031")) {
                    phoneNumber.value = '0031' + phoneNumber.value;
                }
            });
        });

        phoneNumber.addEventListener("change", () => {
            phoneNumber.value = phoneNumber.value.replace(/\s/g, '');

            if (phoneNumber.value[4] === '0') {
                phoneNumber.value = phoneNumber.value.slice(0, 4) + phoneNumber.value.slice(5);
            }
        });
    });
}

if (postalCodes) {
    postalCodes.forEach((postalCode) => {
        postalCode.addEventListener("keydown", (e) => {
            let limit = 6;

            if (/\s/g.test(postalCode.value)) {
                limit = 7;
            }

            if (postalCode.value.length >= limit && e.key !== 'Backspace' && e.key !== 'Tab') {
                e.preventDefault();
            }
        });

        postalCode.addEventListener("paste", () => {
            validatePostalCode(postalCode.value);
        });

        postalCode.addEventListener("change", () => {
            validatePostalCode(postalCode.value);
            postalCode.value = postalCode.value.replace(/\s/g, '');
        });
    });
}

const validatePostalCode = (value) => {
    setTimeout(() => {
        let limit = 6;

        if (/\s/g.test(value)) {
            limit = 7;
        }

        if (value.length > limit) {
            value = '';
        }
    });
}
